<script>
import {myMixins} from "../mixins/myMixins";
import {invoicesService} from "../../Services/Invoices.service";
import {clientsService} from "../../Services/Clients.service";
import {affiliateTitularsService} from "../../Services/AffiliateTitularsService";
import {affiliatedependentsService} from "../../Services/AffiliateDependents.service";

export default {
    name: "Refund",
    mixins: [myMixins],
    props: {
        role_id: {
            type: Number,
            comments: 'Es el rol del usuario que esta cargando la factura, se usa para obtener el directorio donde se guarda el archivo de la factura',
            required: false
        },
        reg_id: {
            type: Number,
            comments: 'Es el id del usuario que esta autenticado',
            required: false
        },
    },
    data() {
        return {
            filter: null,
            isBusy: false,
            showModal: false,
            titleModal: 'Subir Factura',
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            invoice: [],
            fields: [
                {key: 'Reembolsar'},
                {key: 'fecha'},
                {key: 'sku'},
                {key: 'afiliado'},
                {key: 'factura_name'},
                {key: 'concepto'},
                {key: 'subtotal'},
                {key: 'iva'},
                {key: 'total'},
                {key: 'status'},
                {key: 'acciones'},
            ],
            params: {
                limit: 10,
                page: 1,
                where: [
                    {
                        field: 'model_type',
                        operator: '=',
                        value: 'App\\Models\\AffiliateTitular'
                    }
                ],
            },
            paramsAffiliate: {
                sku: 0
            },
            paramsDependent: {
                where: [
                    {
                        field: 'titular_sku',
                        operator: '=',
                        value: ''
                    }
                ],
            },
            company_sku: 0,
            affiliate_id: 0,
            dependent_id: 0,
            clients: [],
            affiliates: [],
            affiliatesDependents: [],
            savedSelectedRows: [],
            selectedRows: [],
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = '';
            resp = await invoicesService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        closeModal() {
            this.showModal = false;
        },
        openModal() {
            this.showModal = true;
        },
        changeLimit() {
            this.index();
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        clickRow(index, item, rowSelected) {
            //console.log('index', index, 'item', item, 'rowSelected', rowSelected, 'type', type);
            if (rowSelected) {
                this.$refs.selectableTable.unselectRow(index);
            } else if (item.paid_at !== 1) {
                this.theRowSelected = true;
                this.$refs.selectableTable.selectRow(index);
            }
        },
        onRowSelected(items) {
            //console.log('onRowSelected', items);
            //FILTRO LOS REGISTROS QUE NO TIENEN TICKET ADMIN
            this.selectedRows = items.filter((item) => item.ticket_admin === 0);
            this.savedSelectedRows = this.selectedRows.map((item) => [item.id]);
        },
        async getInvoiceByAffiliate() {
            this.params.where = [
                {
                    field: 'supplier_id',
                    operator: '=',
                    value: this.affiliate_id
                },
                {
                    field: 'model_type',
                    operator: '=',
                    value: 'App\\Models\\AffiliateTitular'
                }
            ];
            await this.index();
        },
        async getDependentAffiliate() {
            //GET DATA-SKU-CLIENT
            //console.log('this.affiliate_id=', $('#affiliate_id option:selected').data('sku-client'));
            this.paramsAffiliate.where.value = $('#affiliate_id option:selected').data('sku-client');
            this.affiliatesDependents = await affiliatedependentsService.getMany(this.paramsAffiliate);
        },
        async getAffiliates() {
            this.paramsAffiliate.sku = this.company_sku;
            this.affiliates = await affiliateTitularsService.getMany(this.paramsAffiliate);
        },
        async index() {
            this.isBusy = true;
            //console.log('this.params=', this.params)
            this.clients = await clientsService.getClientAsCompany();
            this.pagination = await invoicesService.getMany(this.params);
            //console.log('this.pagination Refund=', this.pagination);
            this.isBusy = false;
        },
    },
    mounted() {
        //console.log('REFUND =', this.savedSelectedRows.length)
        this.index();
    }
}
</script>

<template>
    <div id="quoter-component">
        <b-modal @hide="closeModal" v-model="showModal"
                 id="modal-cotizador" hide-footer size="xl"
                 centered scrollable
                 :title="titleModal" ref="modal-serv">
            <ticket-refund
                :supplier_id="affiliate_id"
                :type_model="'AffiliateTitular'"
                :invoice_array="savedSelectedRows">
            </ticket-refund>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <select name="company_sku" id="company_sku" v-model="company_sku" @change="getAffiliates()">
                                <option :value="0">Seleccione un cliente</option>
                                <option v-for="client in clients" :value="client.sku">
                                    {{ client.sku }} - {{ client.nmComPerMoral }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <select name="affiliate_id" id="affiliate_id" v-model="affiliate_id"
                                    @change="getDependentAffiliate()">
                                <option :value="0">Seleccione un Titular</option>
                                <option v-for="affiliate in affiliates" :value="affiliate.id"
                                        :data-sku-client="affiliate.sku">
                                    {{ affiliate.sku }} - {{ affiliate.nombre }} {{ affiliate.paterno }}
                                    {{ affiliate.materno }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <select name="dependent_id" id="dependent_id" v-model="dependent_id"
                                    @change="getInvoiceByAffiliate()">
                                <option :value="0">Seleccione un Dependiente</option>
                                <option v-for="dependents in affiliatesDependents" :value="dependents.id">
                                    {{ dependents.sku }} - {{ dependents.nombre }} {{ dependents.paterno }}
                                    {{ dependents.materno }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <button v-if="savedSelectedRows.length!==0" class="formSubmit" type="button"
                                    v-on:click="openModalsProviders()">
                                Subir Pagos
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md"
                                 id="my-table"
                                 striped hover
                                 :fields="fields"
                                 :busy="isBusy"
                                 :items="pagination.data"
                                 :filter="filter"
                                 selectable
                                 @row-selected="onRowSelected"
                                 no-select-on-click
                                 ref="selectableTable">
                            <template #head(acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #head(factura)="{item}">
                                <i class="fa-solid fa-file-invoice-dollar"></i>
                            </template>
                            <template #cell(facturar)="{ rowSelected, index, item }">
                                <button class="badge rounded-pill border-0"
                                        :class="rowSelected?'text-bg-green':'text-bg-orange'"
                                        v-if="item.ticket_admin===0 && affiliate_id!==0"
                                        @click="clickRow(index, item, rowSelected)">
                                    <i class="fa-solid fa-angles-up"></i>
                                </button>
                            </template>
                            <template #cell(fecha)="{item}">
                                {{ formatDate(item.created_at) }}
                            </template>
                            <template #cell(sku)="{item}">
                                {{ item.model.sku }}
                            </template>
                            <template #cell(afiliado)="{item}">
                                {{ item.model.nombre }} {{ item.model.paterno }} {{ item.model.materno }}
                            </template>
                            <template #cell(factura_name)="{item}">
                                {{ item.factura_name }}
                            </template>
                            <template #cell(concepto)="{item}">
                                {{ item.concepto }}
                            </template>
                            <template #cell(subtotal)="{item}">
                                {{ formatPrice(item.subtotal) }}
                            </template>
                            <template #cell(iva)="{item}">
                                {{ formatPrice(item.iva) }}
                            </template>
                            <template #cell(total)="{item}">
                                {{ formatPrice(item.total) }}
                            </template>
                            <template #cell(status)="{item}">
                                <span v-if="item.approved_at!=null" class="badge rounded-pill text-bg-success">
                                    <i class="fa-solid fa-circle-check"></i>
                                </span>
                                <span v-else class="badge rounded-pill text-bg-orange">
                                    <i class="fa-solid fa-circle-exclamation"></i>
                                </span>
                            </template>
                            <template #cell(acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">
                                            Borrar
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                            <b-pagination
                                pills
                                align="fill"
                                :hide-goto-end-buttons="true"
                                :limit="3"
                                v-model="pagination.current_page"
                                :total-rows="pagination.total"
                                :per-page="pagination.per_page"
                                aria-controls="my-table"
                                v-on:change="onChange">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<style scoped>

</style>
